"use client";
import { CommentHeader } from "../components/CommentHeader";
import { MessageThread } from "../components/MessageThread";
import { DateDivider } from "../components/DateDriver";
import { TodayThread } from "../components/TodayThread";

export default function Comments({ open }) {
  return (
    <main className="flex flex-col border gap-5 border-gray-300 rounded-lg flex-1 justify-end items-start w-full">
      <CommentHeader open={open} />
      <div className="flex flex-col flex-1 gap-8 justify-end items-center px-6 py-0 w-full pb-10 ">
        <MessageThread />
        <DateDivider />
        <TodayThread />
      </div>
    </main>
  );
}
